export default __webpack_public_path__ + "static/media/blasphemousruin.5a1f5525.png";